const PlotCta = () => {
  const plotTop = document.querySelector('.plot-top');
  const plotCta = document.querySelector('.plot-cta');
  const plotTopHeight = plotTop.offsetHeight;

  if (typeof plotCta !== 'undefined' && plotCta) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > plotTopHeight) {
        plotCta.classList.add('plot-cta--visible');
      } else {
        plotCta.classList.remove('plot-cta--visible');
      }
    });
  }
};

export default PlotCta;
